// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QoUsm","content-wrapper":"styles_content-wrapper__Mds17"};